export default "__VITE_ASSET__CunouKSv__"